import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  pure: false
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const searchInput = args || '';
    if (value == undefined) {
      return [];
    }
    return value.filter(item => {
      return item.name.toLowerCase().includes(searchInput.toLowerCase());
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/search.pipe.ts